var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/EstimationApi/Notifications/subscriptions.ts";
import * as t from 'io-ts';
export var SubscriptionEvent;

(function (_SubscriptionEvent) {
  var subscribeEvent = 'SubscribeEvent';
  var unsubscribeEvent = 'UnsubscribeEvent';
  var SubscriptionType = t.union([t.literal(subscribeEvent), t.literal(unsubscribeEvent)]);
  var Status = t.union([t.literal('Success'), t.literal('Fail'), t.literal('Error')]);
  var SubscribeExplorer;

  (function (_SubscribeExplorer) {
    var Payload;

    (function (_Payload) {
      var io = _Payload.io = function (type) {
        return t.type({
          subscriptionType: type,
          status: Status,
          message: t.union([t["null"], t.string]),
          params: t["null"],
          id: t.number
        });
      };
    })(Payload || (Payload = _SubscribeExplorer.Payload || (_SubscribeExplorer.Payload = {})));

    var CheckupRepository;

    (function (_CheckupRepository) {
      var payload = _CheckupRepository.payload = Payload.io(t.literal('CheckupRepository'));
    })(CheckupRepository || (CheckupRepository = _SubscribeExplorer.CheckupRepository || (_SubscribeExplorer.CheckupRepository = {})));

    var ClassifierRepository;

    (function (_ClassifierRepository) {
      var payload = _ClassifierRepository.payload = Payload.io(t.literal('ClassifierRepository'));
    })(ClassifierRepository || (ClassifierRepository = _SubscribeExplorer.ClassifierRepository || (_SubscribeExplorer.ClassifierRepository = {})));

    var EstimationRepository;

    (function (_EstimationRepository) {
      var payload = _EstimationRepository.payload = Payload.io(t.literal('EstimationRepository'));
    })(EstimationRepository || (EstimationRepository = _SubscribeExplorer.EstimationRepository || (_SubscribeExplorer.EstimationRepository = {})));

    var FieldInspectionRepository;

    (function (_FieldInspectionRepository) {
      var payload = _FieldInspectionRepository.payload = Payload.io(t.literal('FieldInspectionRepository'));
    })(FieldInspectionRepository || (FieldInspectionRepository = _SubscribeExplorer.FieldInspectionRepository || (_SubscribeExplorer.FieldInspectionRepository = {})));

    var is = _SubscribeExplorer.is = function (e) {
      return e.payload.subscriptionType === 'CheckupRepository' || e.payload.subscriptionType === 'ClassifierRepository' || e.payload.subscriptionType === 'EstimationRepository' || e.payload.subscriptionType === 'FieldInspectionRepository';
    };
  })(SubscribeExplorer || (SubscribeExplorer = _SubscriptionEvent.SubscribeExplorer || (_SubscriptionEvent.SubscribeExplorer = {})));

  var SubscribeAssembly;

  (function (_SubscribeAssembly) {
    var Payload;

    (function (_Payload2) {
      var io = _Payload2.io = t.type({
        type: t.literal('AssemblyClassifier'),
        status: Status,
        message: t.union([t["null"], t.string]),
        params: t.type({
          classifierId: t.number
        }),
        id: t.number
      });
    })(Payload || (Payload = _SubscribeAssembly.Payload || (_SubscribeAssembly.Payload = {})));

    var is = _SubscribeAssembly.is = function (e) {
      return e.payload.type === 'AssemblyClassifier';
    };
  })(SubscribeAssembly || (SubscribeAssembly = _SubscriptionEvent.SubscribeAssembly || (_SubscriptionEvent.SubscribeAssembly = {})));

  var SubscribeClassifier;

  (function (_SubscribeClassifier) {
    var Payload;

    (function (_Payload3) {
      var io = _Payload3.io = t.type({
        type: t.literal('UserClassifier'),
        status: Status,
        message: t.union([t["null"], t.string]),
        params: t.type({
          classifierId: t.number
        }),
        id: t.number
      });
    })(Payload || (Payload = _SubscribeClassifier.Payload || (_SubscribeClassifier.Payload = {})));

    var is = _SubscribeClassifier.is = function (e) {
      return e.payload.type === 'UserClassifier';
    };
  })(SubscribeClassifier || (SubscribeClassifier = _SubscriptionEvent.SubscribeClassifier || (_SubscriptionEvent.SubscribeClassifier = {})));

  var SubscribeCheckup;

  (function (_SubscribeCheckup) {
    var Payload;

    (function (_Payload4) {
      var io = _Payload4.io = t.type({
        type: t.literal('Checkup'),
        status: Status,
        message: t.union([t["null"], t.string]),
        params: t.type({
          classifierId: t.number,
          checkupId: t.number
        }),
        id: t.number
      });
    })(Payload || (Payload = _SubscribeCheckup.Payload || (_SubscribeCheckup.Payload = {})));

    var is = _SubscribeCheckup.is = function (e) {
      return e.payload.type === 'Checkup';
    };
  })(SubscribeCheckup || (SubscribeCheckup = _SubscriptionEvent.SubscribeCheckup || (_SubscriptionEvent.SubscribeCheckup = {})));

  var SubscribeEstimation;

  (function (_SubscribeEstimation) {
    var Payload;

    (function (_Payload5) {
      var io = _Payload5.io = t.type({
        type: t.literal('Estimation'),
        status: Status,
        message: t.union([t["null"], t.string]),
        params: t.type({
          classifierId: t.number,
          estimationId: t.number
        }),
        id: t.number
      });
    })(Payload || (Payload = _SubscribeEstimation.Payload || (_SubscribeEstimation.Payload = {})));

    var is = _SubscribeEstimation.is = function (e) {
      return e.payload.type === 'Estimation';
    };
  })(SubscribeEstimation || (SubscribeEstimation = _SubscriptionEvent.SubscribeEstimation || (_SubscriptionEvent.SubscribeEstimation = {})));

  var SubscribeBimFile;

  (function (_SubscribeBimFile) {
    var Payload;

    (function (_Payload6) {
      var io = _Payload6.io = t.type({
        type: t.literal('BimFile'),
        status: Status,
        message: t.union([t["null"], t.string]),
        params: t.type({
          bimFileUrn: t.string
        }),
        id: t.number
      });
    })(Payload || (Payload = _SubscribeBimFile.Payload || (_SubscribeBimFile.Payload = {})));

    var is = _SubscribeBimFile.is = function (e) {
      return e.payload.type === 'BimFile';
    };
  })(SubscribeBimFile || (SubscribeBimFile = _SubscriptionEvent.SubscribeBimFile || (_SubscriptionEvent.SubscribeBimFile = {})));

  var is = _SubscriptionEvent.is = function (e) {
    return e.type === 'SubscribeEvent';
  };

  var Subscribe;

  (function (_Subscribe) {
    var io = _Subscribe.io = t.type({
      type: t.literal(subscribeEvent),
      payload: t.union([SubscribeCheckup.Payload.io, SubscribeClassifier.Payload.io, SubscribeEstimation.Payload.io, SubscribeBimFile.Payload.io, SubscribeAssembly.Payload.io, SubscribeExplorer.CheckupRepository.payload, SubscribeExplorer.ClassifierRepository.payload, SubscribeExplorer.EstimationRepository.payload, SubscribeExplorer.FieldInspectionRepository.payload])
    }, 'SubscribeEvent');
  })(Subscribe || (Subscribe = _SubscriptionEvent.Subscribe || (_SubscriptionEvent.Subscribe = {})));

  var Unsubscribe;

  (function (_Unsubscribe) {
    var io = _Unsubscribe.io = t.type({
      type: t.literal(unsubscribeEvent),
      payload: t.union([SubscribeCheckup.Payload.io, SubscribeClassifier.Payload.io, SubscribeEstimation.Payload.io, SubscribeBimFile.Payload.io, SubscribeAssembly.Payload.io, SubscribeExplorer.CheckupRepository.payload, SubscribeExplorer.ClassifierRepository.payload, SubscribeExplorer.EstimationRepository.payload, SubscribeExplorer.FieldInspectionRepository.payload])
    }, 'UnsubscribeEvent');
  })(Unsubscribe || (Unsubscribe = _SubscriptionEvent.Unsubscribe || (_SubscriptionEvent.Unsubscribe = {})));

  var io = _SubscriptionEvent.io = t.union([SubscriptionEvent.Subscribe.io, SubscriptionEvent.Unsubscribe.io], 'NotificationEvent');
})(SubscriptionEvent || (SubscriptionEvent = {})); // notification.subscruptions.subscribeExplorer()
// notification.subscruptions.unsubscribeExplorer()